<template>
  <v-toolbar
    :color="backgroundColor ? backgroundColor : 'white'"
    class="toolbar-not-padding position-sticky"
    style="z-index:6"
  >
    <v-toolbar-items>
      <v-btn
        text
        light
        class="afrus-drawer-close-btn-border"
        @click="$emit('close')"
      >
        <v-icon :style="{ color: textColor }">close</v-icon>
      </v-btn>
      <v-row align="center">
        <v-col class="py-2">
          <v-list-item v-if="typeTitle === 'text'">
            <span
              class="font-weight-bold"
              style="padding: 0px 10px;"
              :style="{ color: textColor }"
              >{{ title }}</span
            >
          </v-list-item>
          <v-list-item v-else-if="typeTitle === 'icon'">
            <v-icon :style="{ color: textColor }" >{{ icon }}</v-icon>
            <span
              class="font-weight-bold"
              style="padding: 0px 10px;"
              :style="{ color: textColor }"
              >{{ title }}</span
            >
          </v-list-item>
          <v-list-item v-else-if="typeTitle === 'input'" class="hidden-xs-only">
            <v-text-field ref="title_navbar" :value="value" @input="change">
              <!-- <template v-slot:prepend-inner>
                <img
                  :src="require(`~/assets/img/dashboard/${icon}.png`)"
                  class="icon-message-size filter-icon-message"
                />
              </template> -->
            </v-text-field>
          </v-list-item>
          <v-list-item v-else>
            <strong
              :class="status === 3 ? 'grey--text text--lighten-1' : ''"
              :style="{ color: textColor }"
              >{{ title }}</strong
            >
            <span
              class="dot"
              :style="{
                backgroundColor:
                  status !== 1
                    ? status === 2
                      ? 'red'
                      : ''
                    : 'rgb(26, 189, 26)'
              }"
            ></span>
          </v-list-item>
        </v-col>
      </v-row>
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <slot></slot>
      <template v-if="buttonSave">
        <div class="hidden-xs-only d-flex align-center px-4">
          <v-btn
            rounded
            color="#2661FF"
            @click="$emit('save')"
            v-text="$t('general.save')"
          />
        </div>
      </template>
      <template v-if="options">
        <v-divider vertical />
        <v-menu
          left
          offset-y
          nudge-bottom="10"
          transition="slide-y-transition"
          min-width="180px"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text>
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="option in filteredOptions"
              :key="option.name"
              @click="$emit(option.name)"
            >
              <span :style="{ color: textColor }">
                {{ option.text }}
              </span>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <!-- <v-menu v-if="options" class="hidden-sm-and-up">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="buttonSave">
            <v-list-item-content>
              <v-list-item-title @click="$emit('save')">{{
                $t('general.save')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-for="option in filteredOptions" :key="option.name">
            <v-list-item-content>
              <v-list-item-title @click="$emit(option.name)">{{
                option.text
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu> -->
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
export default {
  name: "BaseToolbar",
  props: {
    typeTitle: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: null
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    buttonSave: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: String,
      required: false,
      default: null
    },
    options: {
      type: Array,
      required: false,
      default: null
    },
    status: {
      type: Number,
      required: false,
      default: null
    },
    backgroundColor: {
      type: String,
      required: false,
      default: "primary"
    }
  },
  computed: {
    filteredOptions() {
      return this.options.filter(e => e.show);
    },
    textColor() {
      const { backgroundColor } = this;
      return this.getContrastColor(backgroundColor);
    }
  },
  mounted() {
    if (this.typeTitle === "input") {
      this.setFocus();
    }
  },
  methods: {
    change(value) {
      this.$emit("input", value);
    },
    setFocus() {
      this.$refs.title_navbar.focus();
    },
    getContrastColor(backgroundColor) {
      // Map of named colors to hex values
      const colorMap = {
        primary: "#2661FF"
      };

      // Convert named colors to hex
      if (colorMap[backgroundColor]) {
        backgroundColor = colorMap[backgroundColor];
      }

      // Convert the prop into hex
      const hexColor = /^#/.test(backgroundColor)
        ? backgroundColor
        : this.convertToHex(backgroundColor);

      // Extract RGB components
      const r = parseInt(hexColor.slice(1, 3), 16);
      const g = parseInt(hexColor.slice(3, 5), 16);
      const b = parseInt(hexColor.slice(5, 7), 16);

      // Calculate luminosity
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

      return luminance > 0.5 ? "#000" : "#fff";
    },
    convertToHex(color) {
      const match = color.match(/\d+/g);
      if (!match) {
        throw new Error("Invalid color format");
      }
      return `#${match
        .map(x =>
          parseInt(x)
            .toString(16)
            .padStart(2, "0")
        )
        .join("")}`;
    }
  }
};
</script>

<style>
.toolbar-not-padding .v-toolbar__content {
  padding: 0;
}
</style>
